<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title>{{ "Unmatched" | t }}</v-toolbar-title>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" />

        <!--    Right drawer    -->
        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="800">
            <unmatched-shops-view v-if="$route.name === 'unmatched-shops-view'" />
            <unmatched-client-view v-if="$route.name === 'unmatched-client-view'" />
        </v-navigation-drawer>

        <!-- Main content -->
        <v-main>
            <!-- Warning when rematch task is running -->
            <v-alert
                v-if="rematchTaskRunning"
                type="warning"
                dense
                class="ma-0 rounded-0"
                icon="sync"
            >
                {{ "Rematch task is running. Data may change and modifications may fail." | t }}
            </v-alert>

            <!-- Tabs -->
            <v-tabs
                v-model="activeTabModel"
                color="bal-red"
                slider-color="bal-red"
                background-color="white"
                grow
                height="32"
                class="unmatched-tabs"
            >
                <v-tab key="clients">
                    {{ 'Clients' | t }} ({{ unmatchedClientsCount }})
                </v-tab>
                <v-tab key="shops">
                    {{ 'Shops' | t }} ({{ unmatchedShopsCount }})
                </v-tab>
            </v-tabs>

            <!-- Tab content -->
            <unmatched-clients-list v-if="activeTab === 'clients'" />
            <unmatched-shops-list v-else />
        </v-main>

        <!-- Footer -->
        <page-footer />

        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Store from "../store";
import UnmatchedShopsView from "../pages/unmatched-shops/unmatched-shops-view";
import UnmatchedShopsList from "../pages/unmatched-shops/unmatched-shops-list";
import UnmatchedClientsList from "../pages/unmatched-shops/unmatched-clients-list";
import UnmatchedClientView from "../pages/unmatched-shops/unmatched-client-view";

export default {
    name: "unmatched-shops",
    components: {
        PageFooter,
        MainDrawer,
        UnmatchedShopsView,
        UnmatchedShopsList,
        UnmatchedClientsList,
        UnmatchedClientView
    },
    data() {
        return {
            mainDrawerOpen: null
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
        await this.fetchCountries();
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        ...mapActions(["fetchCountries"]),
        ...mapMutations("UnmatchedShopsStore", ["setActiveTab"]),
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.mainDrawerOpen) {
                this.$router.push({ name: "unmatched-shops-list" });
            }
            if (
                this.activeUnmatchedShop &&
                Object.keys(this.activeUnmatchedShop).length > 0 &&
                document.activeElement.tagName !== "INPUT"
            ) {
                let currentUserIndex = this.unmatchedShops.findIndex(p => p.id === this.activeUnmatchedShop.id);
                if (e.key === "ArrowUp") {
                    if (currentUserIndex !== 0) {
                        const newShop = this.unmatchedShops[currentUserIndex - 1];
                        Store.dispatch("UnmatchedShopsStore/getUnmatchedShopsData", {
                            invoiceId: newShop.id,
                            invoiceType: newShop.type
                        });
                        this.$router.push({
                            name: this.$route.name,
                            params: { invoiceId: newShop.id, invoiceType: newShop.type }
                        });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentUserIndex + 1 !== this.unmatchedShops.length) {
                        const newShop = this.unmatchedShops[currentUserIndex + 1];
                        Store.dispatch("UnmatchedShopsStore/getUnmatchedShopsData", {
                            invoiceId: newShop.id,
                            invoiceType: newShop.type
                        });
                        this.$router.push({
                            name: this.$route.name,
                            params: { invoiceId: newShop.id, invoiceType: newShop.type }
                        });
                    }
                }
            }
        }
    },
    computed: {
        ...mapState("UnmatchedShopsStore", [
            "drawerOpen",
            "requestSuccess",
            "activeUnmatchedShop",
            "unmatchedShops",
            "activeTab",
            "activeUnmatchedClient",
            "rematchTaskRunning"
        ]),
        ...mapGetters("UnmatchedShopsStore", ["unmatchedShopsCount", "unmatchedClientsCount"]),
        activeTabModel: {
            get() {
                const tabs = ['clients', 'shops'];
                return tabs.indexOf(this.activeTab);
            },
            set(index) {
                const tabs = ['clients', 'shops'];
                this.setActiveTab(tabs[index]);
            }
        }
    }
};
</script>

<style scoped>
.v-input__icon--prepend-inner .v-icon {
    margin-top: 0px !important;
}

.unmatched-tabs {
    border-bottom: 1px solid #e0e0e0;
}

::v-deep .unmatched-tabs .v-tab {
    font-weight: 500;
    letter-spacing: 0;
    text-transform: none;
    font-size: 13px;
}
</style>
